<script>
import pessoasService from "@/services/Pessoas/pessoasService";

import { PessoaCaracteristica, EnderecoPadrao } from "@/store/cwl_enums";

import statesService from "@/services/States/statesService";
import banksService from "@/services/Banks/banksService";
import investmentsProfileService from "@/services/InvestmentsProfile/investmentsProfileService";
import segmentsService from "@/services/Segments/segmentsService";
import valuesService from "@/services/Values/valuesService";

import Vue from "vue";
import HelperPlugin from "@/plugins/HelperPlugin";
Vue.use(HelperPlugin);

import { VTooltip } from "v-tooltip";
Vue.directive("tooltip", VTooltip);

import birthDatepicker from "vue-birth-datepicker";
import { email } from "vuelidate/lib/validators";
import { cpf, cep } from "@/validate/customValidators.js";

import settingsService from "@/services/Settings/settingsService";

const limiteInvestimento = (investimentos, valor, limiteValor) => {
  if (investimentos > 1000000) {
    return true;
  } else if (valor > limiteValor) {
    return false;
  } else {
    return true;
  }
};

export default {
  name: "investor-informations",
  components: {
    birthDatepicker
  },
  computed: {
    loggedInUser() {
      return this.$store.getters.isLoggedIn;
    },
    loggedPessoa() {
      return this.$store.getters.getPessoa;
    },
    order() {
      return this.$store.getters.getOrder;
    }
  },
  data() {
    return {
      limite_investimento: "",
      limite_investimento_puro: 0,
      settings: {},

      userInformations: [],
      cepForSearch: "",
      pessoa: {
        dados_complementares: {
          dados_bancarios: {},
          perfil: {}
        },
        documento: {},
        telefone: {},
        endereco: {},
        email: {}
      },
      birthday: "",
      telefone: "",
      telefone_original: "",
      email: "",
      email_original: "",
      model: {
        states: [],
        banks: [],
        segments: [],
        values: [],
        profiles: []
      },
      PessoaCaracteristica: PessoaCaracteristica,
      stateSelected: undefined,
      submodalidade: process.env.VUE_APP_SUBTYPE
    };
  },
  validations: {
    pessoa: {
      email: {
        email: {
          valid: email
        }
      },
      documento: {
        numero: {
          valid: cpf
        }
      }
    },
    limite_investimento: {
      valid: function() {
        if (!this.settings.validar_limite_investimento) return true;
        var investimentos =
          this.pessoa.dados_complementares.perfil.investimentos_financeiros ||
          0;
        var valor = this.order.item.order.totalValue || 0;
        var limiteValor = this.limite_investimento_puro || 0;
        return limiteInvestimento(investimentos, valor, limiteValor);
      }
    },
    cepForSearch: {
      valid: cep
    }
  },
  async mounted() {
    this.getBanks();
    await this.getStates();
    this.getProfiles();
    this.getSegments();
    this.getValues();
    this.getSettings();

    if (!this.loggedPessoa) {
      this.pessoa = this.$CWLNewPessoaPadrao();
    } else {
      this.getPessoa();
    }
  },
  methods: {
    async changeCEP() {
      const cepWithoutMask = (this.cepForSearch.match(/\d+/g) || []).join("");
      if (cepWithoutMask.length == 8 && !this.skipCepSearch) {
        if (!this.isLoadingEnderecoPessoa) {
          this.isLoadingEnderecoPessoa = true;

          var _endereco =
            (await pessoasService.searchAddressByZipcode(this.cepForSearch)) ||
            EnderecoPadrao;

          var _states = this.model.states;

          var _filtered = _states.filter(s => s.uf == _endereco.estado);
          _endereco.estado = _filtered.length == 0 ? null : _filtered[0];

          this.pessoa.endereco = Object.assign({}, _endereco);

          this.isLoadingEnderecoPessoa = false;
        }
      } else if (!this.isLoadingEnderecoPessoa && !this.skipCepSearch) {
        this.pessoa.endereco = {};
      }
      this.skipCepSearch = false;
    },
    async getSettings() {
      this.settings = await settingsService.getPublicSettings();
    },
    updateLimiteInvestimento() {
      const rendaBruta = this.pessoa.dados_complementares.perfil
        .renda_bruta_anual
        ? this.pessoa.dados_complementares.perfil.renda_bruta_anual
        : 0;
      const investimentosFinanceiros = this.pessoa.dados_complementares.perfil
        .investimentos_financeiros
        ? this.pessoa.dados_complementares.perfil.investimentos_financeiros
        : 0;
      const investimentosNestaPlataforma = this.pessoa.dados_complementares
        .perfil.investimentos_nesta_plataforma
        ? this.pessoa.dados_complementares.perfil.investimentos_nesta_plataforma
        : 0;
      const investimentosOutrasPlataformas = this.pessoa.dados_complementares
        .perfil.investimentos_outras_plataformas
        ? this.pessoa.dados_complementares.perfil
            .investimentos_outras_plataformas
        : 0;
      var montante = 0;

      if (investimentosFinanceiros > 1000000) {
        this.limite_investimento = "Ilimitado";
      } else if (investimentosFinanceiros > 100000 || rendaBruta > 100000) {
        var calculo10Porcento = 0;
        if (investimentosFinanceiros > rendaBruta) {
          calculo10Porcento = investimentosFinanceiros * 0.1;
        } else {
          calculo10Porcento = rendaBruta * 0.1;
        }
        montante =
          investimentosNestaPlataforma + investimentosOutrasPlataformas;
        const limiteInvestimentoPuro = calculo10Porcento - montante;

        const limiteInvestimentoPreFormatado = parseFloat(
          limiteInvestimentoPuro
        )
          .toFixed(2)
          .replace(".", ",");
        const limiteInvestimento =
          "R$ " +
          limiteInvestimentoPreFormatado
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.limite_investimento = limiteInvestimento;

        this.limite_investimento_puro = limiteInvestimentoPuro;
      } else {
        montante =
          investimentosNestaPlataforma + investimentosOutrasPlataformas;
        const limiteInvestimentoPuro = 10000 - montante;

        const limiteInvestimentoPreFormatado = parseFloat(
          limiteInvestimentoPuro
        )
          .toFixed(2)
          .replace(".", ",");
        const limiteInvestimento =
          "R$ " +
          limiteInvestimentoPreFormatado
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        this.limite_investimento = limiteInvestimento;
        this.limite_investimento_puro = limiteInvestimentoPuro;
      }
    },
    nextStep() {
      this.$store.commit("SET_USER", this.pessoa);

      this.$emit("nextStep");
    },
    async updateInformacoesPessoa() {
      this.pessoa.endereco.estado = this.stateSelected;

      if (this.$v.$invalid) {
        return this.$toasted.show(
          "Revise suas informações financeiras ou ajuste o valor a ser investido.",
          {
            icon: "times",
            className: "error"
          }
        );
      }

      this.$CWLVincularCaracteristicaPessoa(
        this.pessoa,
        PessoaCaracteristica.Investidor,
        false
      );

      if (this.pessoa.id) {
        await pessoasService.updatePessoa(this.pessoa.id, this.pessoa);

        this.nextStep();
      } else {
        const pessoaCreatedOnFirebase = await pessoasService.createNewPessoa(
          this.pessoa
        );
        const pessoaCreated = await pessoasService.getPessoa(
          pessoaCreatedOnFirebase.id
        );

        const newObj = pessoaCreated.data();
        newObj.id = pessoaCreated.id;
        this.pessoa = newObj;

        this.nextStep();
      }
    },

    async getBanks() {
      const banks = await banksService.getAllBanks();

      banks.forEach(bank => {
        const newBank = bank.data();
        newBank.id = bank.id;

        this.model.banks.push(newBank);
      });
    },

    async getStates() {
      const states = await statesService.getAllStates();

      states.forEach(state => {
        const newState = state.data();
        newState.id = state.id;

        this.model.states.push(newState);
      });
    },

    async getProfiles() {
      const profiles = await investmentsProfileService.getAllProfiles();

      profiles.forEach(profile => {
        const newProfile = profile.data();
        newProfile.id = profile.id;

        this.model.profiles.push(newProfile);
      });
    },

    async getSegments() {
      const segments = await segmentsService.getAllSegments();

      segments.forEach(segment => {
        const newSegment = segment.data();
        newSegment.id = segment.id;

        this.model.segments.push(newSegment);
      });
    },

    async getValues() {
      const values = await valuesService.getAllValues();

      values.forEach(value => {
        const newValue = value.data();
        newValue.id = value.id;

        this.model.values.push(newValue);
      });
    },

    setCurrentStateCode() {
      if (typeof this.pessoa.endereco.estado === "object") {
        this.stateSelected = this.pessoa.endereco.estado;
      } else if (this.model.states && this.pessoa.endereco.estado) {
        for (let index = 0; index < this.model.states.length; index++) {
          const _state = this.model.states[index];
          if (_state.uf == this.pessoa.endereco.estado) {
            this.stateSelected = _state;
            break;
          }
        }
      }
    },
    async getPessoa() {
      const { pessoa_id } = this.loggedPessoa;

      const pessoa = await pessoasService.getPessoa(pessoa_id);

      this.pessoa = pessoa.data();

      if (!this.pessoa.dados_complementares.dados_bancarios) {
        this.pessoa.dados_complementares.dados_bancarios = {};
      }

      if (!this.pessoa.dados_complementares.perfil) {
        this.pessoa.dados_complementares.perfil = {};
      }

      this.pessoa.id = pessoa.id;

      this.cepForSearch = this.pessoa.endereco ? this.pessoa.endereco.cep : "";

      this.setCurrentStateCode();

      this.updateLimiteInvestimento();
    }
  }
};
</script>

<template>
  <div class="investor-columns">
    <h4>Por favor, informe os dados abaixo</h4>

    <form @submit.prevent="updateInformacoesPessoa()">
      <div class="investor-form card">
        <h5>Meus Dados</h5>
        <div class="columns">
          <div class="column">
            <label>Nome completo*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu nome completo"
              v-model="pessoa.nome"
              required
            />
          </div>

          <div class="column">
            <label>RG*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu RG"
              v-model="pessoa.dados_complementares.rg"
              required
            />
          </div>

          <div class="column">
            <label>CPF*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu CPF"
              v-mask="'###.###.###-##'"
              v-model="pessoa.documento.numero"
              required
            />
            <div class="form-group">
              <div
                class="error"
                v-if="
                  pessoa.documento.numero != '' &&
                    !$v.pessoa.documento.numero.valid
                "
              >
                Informe um CPF válido.
              </div>
            </div>
          </div>

          <div class="column">
            <div class="form-group">
              <label>E-mail*</label>
              <input
                type="email"
                class="form-control fix-rounded-right"
                placeholder="Digite seu melhor e-mail"
                v-model="pessoa.email.email"
                required
              />
              <div
                class="error"
                v-if="pessoa.email.email != '' && !$v.pessoa.email.email.valid"
              >
                Informe um e-mail válido.
              </div>
            </div>
          </div>

          <div class="column">
            <label>Data de Nascimento*</label>
            <birth-datepicker
              v-model="pessoa.dados_complementares.birthday"
              style="border: 0;"
              :valueIsString="true"
              :high="true"
              :hideHeader="true"
              :attachment="'bottom'"
              :delimiter="'/'"
              :placeholder="'Digite seu nascimento. Ex: 27/12/1993'"
              required
              :locale="[
                'Jan',
                'Fev',
                'Mar',
                'Abr',
                'Mai',
                'Jun',
                'Jul',
                'Ago',
                'Set',
                'Out',
                'Nov',
                'Dez'
              ]"
            />
          </div>

          <div class="column">
            <label>Telefone*</label>
            <input
              type="telefone"
              class="input"
              placeholder="Digite seu melhor telefone"
              v-model="pessoa.telefone.telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              required
            />
          </div>

          <div class="column">
            <label>Estado Civil*</label>
            <select v-model="pessoa.dados_complementares.estado_civil" required>
              <option value="solteiro">Solteiro(a)</option>
              <option value="casado">Casado(a)</option>
              <option value="divorciado">Divorciado(a)</option>
              <option value="viuvo">Viúvo(a)</option>
              <option value="separado_judicialmente"
                >Separado(a) Judicialmente</option
              >
              <option value="outro">Outro</option>
            </select>
          </div>

          <div class="column">
            <label>Gênero</label>
            <select v-model="pessoa.dados_complementares.genero" required>
              <option value="masculino">Masculino</option>
              <option value="feminino">Feminino</option>
              <option value="outro">Outro</option>
            </select>
          </div>
        </div>

        <h5>Endereço</h5>
        <div class="columns">
          <div class="column">
            <label>CEP*</label>
            <input
              type="text"
              class="input"
              v-mask="'#####-###'"
              placeholder="Digite seu CEP"
              v-model="cepForSearch"
              v-on:input="changeCEP"
              required
            />
            <div class="form-group">
              <div
                class="error"
                v-if="cepForSearch != '' && !$v.cepForSearch.valid"
              >
                Informe um CEP válido.
              </div>
            </div>
          </div>

          <div class="column">
            <label>Rua*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Rua"
              v-model="pessoa.endereco.rua"
              required
            />
          </div>

          <div class="column">
            <label>Número*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Número"
              v-model="pessoa.endereco.numero"
              required
            />
          </div>

          <div class="column">
            <label>Complemento</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Complemento"
              v-model="pessoa.endereco.complemento"
            />
          </div>

          <div class="column">
            <label>Bairro*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Bairro"
              v-model="pessoa.endereco.bairro"
              required
            />
          </div>

          <div class="column">
            <label>Cidade</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Cidade"
              v-model="pessoa.endereco.cidade"
              required
            />
          </div>

          <div class="column">
            <label>Estado</label>
            <select v-model="stateSelected" required>
              <option
                :value="state"
                v-for="(state, index) in model.states"
                :key="index"
              >
                {{ state.name }}
              </option>
            </select>
          </div>
        </div>

        <h5>Profissão</h5>
        <div class="columns">
          <div class="column">
            <label>Ocupação*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Ocupação"
              v-model="pessoa.dados_complementares.ocupacao"
              required
            />
          </div>

          <div class="column">
            <label>Nome da Empresa*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite o nome de sua Empresa"
              v-model="pessoa.dados_complementares.nome_empresa"
              required
            />
          </div>

          <div class="column">
            <label>Cargo*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite seu Cargo"
              v-model="pessoa.dados_complementares.cargo"
              required
            />
          </div>
        </div>

        <h5>Dados Bancários</h5>
        <div class="columns">
          <div class="column">
            <label>Agência sem dígito*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Agência"
              v-model="pessoa.dados_complementares.dados_bancarios.agencia"
              required
            />
          </div>

          <div class="column">
            <label>Conta com dígito*</label>
            <input
              type="text"
              class="input"
              placeholder="Digite sua Conta"
              v-model="pessoa.dados_complementares.dados_bancarios.conta"
              required
            />
          </div>

          <div class="column">
            <label>Banco*</label>
            <select
              v-model="pessoa.dados_complementares.dados_bancarios.banco"
              required
            >
              <option
                :value="bank.name"
                v-for="(bank, index) in model.banks"
                :key="index"
              >
                {{ bank.name }}
              </option>
            </select>
          </div>
        </div>

        <h5>Perfil de Investimento</h5>
        <div class="columns">
          <div class="column is-full">
            <label
              >Qual situação melhor se encaixa ao seu perfil atual em relação a
              investimentos? (opcional)</label
            >
            <select v-model="pessoa.dados_complementares.perfil.perfil">
              <option
                :value="profile.profile"
                v-for="(profile, index) in model.profiles"
                :key="index"
              >
                {{ profile.profile }}
              </option>
            </select>
          </div>

          <div class="column is-full">
            <label
              >Qual o principal segmento você tem interesse em investir?
              (opcional)</label
            >
            <select v-model="pessoa.dados_complementares.perfil.segmento">
              <option
                :value="segment.name"
                v-for="(segment, index) in model.segments"
                :key="index"
              >
                {{ segment.name }}
              </option>
            </select>
          </div>

          <div class="column is-full">
            <label
              >Quanto do seu patrimônio você está disposto a investir<span
                v-if="submodalidade == '588'"
              >
                em startups</span
              >? (opcional)</label
            >
            <select v-model="pessoa.dados_complementares.perfil.valor">
              <option
                :value="value.values"
                v-for="(value, index) in model.values"
                :key="index"
              >
                {{ value.values }}
              </option>
            </select>
          </div>

          <div class="checkboxes">
            <div class="column is-full">
              <input
                type="checkbox"
                v-model="pessoa.dados_complementares.aparecer_investidor"
              />
              <label>Concordo em aparecer como investidor</label>
            </div>

            <div class="column is-full">
              <input
                v-model="pessoa.dados_complementares.politicamente_exposto"
                type="checkbox"
              />
              <label>Sou uma pessoa politicamente exposta</label>
            </div>
          </div>

          <div class="column is-full" v-if="submodalidade == '588'">
            <label
              >Outros investimentos através de plataformas de investimento
              Coletivo igual a essa no ano atual (regulamentada CVM
              88/22).</label
            >
            <currency-input
              v-model="
                pessoa.dados_complementares.perfil
                  .investimentos_outras_plataformas
              "
              class="input"
              currency="BRL"
              locale="pt-br"
              placeholder="Digite o valor dos Investimentos"
              :distraction-free="false"
              required
              v-on:focusout="updateLimiteInvestimento"
            />
          </div>

          <div class="column is-full" v-if="submodalidade == '588'">
            <label>Total Investido no ano nesta plataforma</label>
            <currency-input
              v-model="
                pessoa.dados_complementares.perfil
                  .investimentos_nesta_plataforma
              "
              disabled
              readonly
              class="input"
              currency="BRL"
              locale="pt-br"
              placeholder="R$ 0,00"
              :distraction-free="false"
              required
            />
          </div>

          <div class="column is-full">
            <label v-if="submodalidade == '588'"
              >Informe sua Renda Bruta Anual</label
            >
            <label v-if="submodalidade == 'bacen'"
              >Informe sua renda mensal</label
            >
            <currency-input
              v-model="pessoa.dados_complementares.perfil.renda_bruta_anual"
              class="input"
              currency="BRL"
              locale="pt-br"
              :placeholder="
                submodalidade == '588'
                  ? 'Digite sua Renda Bruta Anual'
                  : 'Informe sua renda mensal'
              "
              v-on:focusout="updateLimiteInvestimento"
              :distraction-free="false"
            />
          </div>

          <div class="column is-full">
            <label for="financial-investments" v-if="submodalidade == '588'"
              >Informe o valor de seus Investimentos Financeiros</label
            >
            <label for="financial-investments" v-if="submodalidade == 'bacen'"
              >Informe o valor do seu patrimônio</label
            >
            <currency-input
              v-model="
                pessoa.dados_complementares.perfil.investimentos_financeiros
              "
              id="financial-investments"
              class="form-control"
              :placeholder="
                submodalidade == '588'
                  ? 'Informe o valor de seus Investimentos Financeiros'
                  : 'Informe o valor do seu patrimônio'
              "
              currency="BRL"
              locale="pt-br"
              v-on:focusout="updateLimiteInvestimento"
              :distraction-free="false"
            />
          </div>

          <div class="column is-full" v-if="submodalidade == '588'">
            <label>Limite Atual de Investimento</label>
            <input
              type="text"
              class="input"
              v-model="limite_investimento"
              readonly="readonly"
            />
          </div>
          <div class="form-group">
            <div
              class="error"
              v-if="limite_investimento != '' && !$v.limite_investimento.valid"
            >
              Segundo as normas da CVM e as informações de cadastro dos campos
              <b>Renda Brutal Anual</b> e <b>Investimentos Financeiros</b> seu
              limite atual de investimento, considerando os valores já
              investidos, é de <b>R$ 10.000,00</b>.
            </div>
          </div>
        </div>
      </div>

      <div class="buttons">
        <button class="button is-info" type="submit">
          Prosseguir
        </button>
      </div>
    </form>
  </div>
</template>

<style scoped>
.card {
  padding: 30px 18px;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
  background: #f5f6fa;
  border: 0;
  margin-top: 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  border-radius: 0.2857rem;
}
.card-img-top {
  border-top-left-radius: calc(0.2857rem - 0.0625rem);
  border-top-right-radius: calc(0.2857rem - 0.0625rem);
  text-align: center;
  width: 512px;
  height: 342px;
}

img {
  border-radius: 0.2857rem;
  vertical-align: middle;
  border-style: none;
  max-width: 500px;
}

.card .card-body {
  padding: 15px;
}

h6,
.h6 {
  text-transform: uppercase;
  font-weight: 500;
}

.alert.alert-success {
  background-color: #00bf9a;
}

.alert {
  border: 0;
  color: #ffffff;
}

.alert {
  position: relative;
  padding: 0.9rem 1.25rem;
  margin-bottom: 1rem;
  border: 0.0625rem solid transparent;
  border-radius: 0.2857rem;
}

h5,
.h5 {
  font-size: 0.8125rem;
}

.card-text {
  color: #333;
  font-weight: 300;
  font-size: 0.875rem;
  font-family: "Poppins", sans-serif;
  margin-bottom: 5px;
}
</style>
